import type { UserPermission } from '@lotta/shared/types-types';

export const getUserPermissions = (retailUnit: string, permissions: UserPermission[]) => {
  const roles: string[] = [];
  permissions.forEach((permission) => {
    if (permission.retailUnitId === retailUnit) {
      roles.push(permission.permission);
    }
  });
  return roles;
};
